import React, { useState, useEffect } from 'react';
import axios from 'axios';
const TaleplerPage = () => {
  const [talepler,setTalepler] = useState([]);
  const [yukleniyor,setYukleniyor] = useState(true);
  const [filtre,setFiltre] = useState('hepsi');
  useEffect(()=>{axios.get('/api/talepler/hepsi').then(r=>setTalepler(r.data)).catch(console.error).finally(()=>setYukleniyor(false));},[]);
  const fmt = t=>t?new Date(t).toLocaleDateString('tr-TR'):'-';
  const filtrelenmis = talepler.filter(t=>filtre==='hepsi'?true:t.durum===filtre);
  return (
    <div>
      <div style={{marginBottom:'1.5rem'}}><h2 style={{fontSize:'22px',marginBottom:'4px'}}>Tüm Talepler</h2><p style={{fontSize:'13px',color:'var(--yazi-ikincil)'}}>Personellerin vize evrak taleplerini görüntüleyin.</p></div>
      <div className="stats-grid">
        <div className="stat-kart"><div className="stat-sayi">{talepler.length}</div><div className="stat-etiket">Toplam Talep</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{color:'var(--sari)'}}>{talepler.filter(t=>t.durum==='bekliyor').length}</div><div className="stat-etiket">Bekleyen</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{color:'var(--yesil)'}}>{talepler.filter(t=>t.durum==='tamamlandi').length}</div><div className="stat-etiket">Tamamlanan</div></div>
      </div>
      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <div style={{padding:'1rem 1.25rem',borderBottom:'1px solid var(--border)',display:'flex',gap:'8px'}}>
          {['hepsi','bekliyor','tamamlandi'].map(f=>(
            <button key={f} className={`btn btn-sm ${filtre===f?'btn-primary':'btn-secondary'}`} onClick={()=>setFiltre(f)}>
              {f==='hepsi'?'Hepsi':f==='bekliyor'?'Bekleyenler':'Tamamlananlar'}
            </button>
          ))}
        </div>
        {yukleniyor?<div style={{padding:'3rem',textAlign:'center',color:'var(--yazi-ikincil)'}}>Yükleniyor...</div>
        :filtrelenmis.length===0?<div style={{padding:'3rem',textAlign:'center',color:'var(--yazi-ikincil)'}}>Talep bulunamadı.</div>
        :<div className="tablo-wrapper"><table>
          <thead><tr><th>Personel</th><th>Pozisyon</th><th>Ülke</th><th>İzin Tarihleri</th><th>Sponsor</th><th>Talep Tarihi</th><th>Durum</th></tr></thead>
          <tbody>{filtrelenmis.map(t=>(
            <tr key={t.id}>
              <td><div style={{fontWeight:'500'}}>{t.ad} {t.soyad}</div><div style={{fontSize:'12px',color:'var(--yazi-ikincil)'}}>{t.personel_email}</div></td>
              <td>{t.pozisyon}</td><td>{t.gidilecek_ulke}</td>
              <td>{fmt(t.izin_baslangic)} — {fmt(t.izin_bitis)}</td>
              <td>{t.sponsor?<span className="badge badge-tamamlandi">Var</span>:<span style={{color:'var(--yazi-ikincil)'}}>—</span>}</td>
              <td>{fmt(t.olusturma_tarihi)}</td>
              <td><span className={`badge badge-${t.durum==='tamamlandi'?'tamamlandi':'bekliyor'}`}>{t.durum==='tamamlandi'?'Tamamlandı':'Bekliyor'}</span></td>
            </tr>
          ))}</tbody>
        </table></div>}
      </div>
    </div>
  );
};
export default TaleplerPage;
